import { ContactThankYouProps } from './contact-thank-you.props';
import LazyLoad from 'react-lazyload';
import { socialMedia } from '../../../enums/social-media';
import React from 'react';

export const ContactThankYouMolecule = (props: ContactThankYouProps) => {
  return (
    <div className="">
      <LazyLoad offset={100}>
        <img
          src="/images/icons/thank-you-check.svg"
          className="mx-auto mb-6 lg:mb-7"
        />
      </LazyLoad>
      <h3 className="text-waldo-blue block underline">{props.title}</h3>
      <p className="text-waldo-blue mt-8  mb-7">{props.desc}</p>
      <ul className="list-none flex flex-row justify-center items-start m-0 p-0">
        {socialMedia.map((media, index) => (
          <li key={index}>
            <a
              className={`block social-icon px-1.5 lg:px-2.5 w-12 h-12 
                    transition duration-300  transform hover:scale-125 
                    social-media-link-${media.image}`}
              href={media.href}
              target="_blank"
              rel="noreferrer"
            >
              <LazyLoad offset={100}>
                <img
                  src={`/images/social/${media.image}.svg`}
                  className="w-6 h-6 block"
                  alt={`${media.image} social media image`}
                />
              </LazyLoad>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
